export const HOMEPAGE_MAX_VISIBLE_LIKES = 6;
export const MINIMUM_PREVIEW_ITEMS = 4;
